export default __webpack_public_path__ + "static/media/fast.ae963540.svg";